/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The LoggedInUser model module.
* @module model/LoggedInUser
* @version 1.0.0
*/
export default class LoggedInUser {
    /**
    * Constructs a new <code>LoggedInUser</code>.
    * Данные и роли пользователя
    * @alias module:model/LoggedInUser
    * @class
    * @param login {String} Логин пользователя
    * @param roles {Array.<String>} Роли пользователя. Отражает то, какими правами пользователь обладает
    */

    constructor(login, roles) {
        

        
        

        this['login'] = login;this['roles'] = roles;

        
    }

    /**
    * Constructs a <code>LoggedInUser</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoggedInUser} obj Optional instance to populate.
    * @return {module:model/LoggedInUser} The populated <code>LoggedInUser</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoggedInUser();

            
            
            

            if (data.hasOwnProperty('login')) {
                obj['login'] = ApiClient.convertToType(data['login'], 'String');
            }
            if (data.hasOwnProperty('roles')) {
                obj['roles'] = ApiClient.convertToType(data['roles'], ['String']);
            }
        }
        return obj;
    }

    /**
    * Логин пользователя
    * @member {String} login
    */
    login = undefined;
    /**
    * Роли пользователя. Отражает то, какими правами пользователь обладает
    * @member {Array.<String>} roles
    */
    roles = undefined;








}


